<template>
  <section class="SideFilterDropdown">
    <div class="head flex items-center my-4 pb-4 border-b">
      <h2 class="flex-grow text-base text-uppercase font-bold" @click.stop="toggleCollapse">
        {{ title }}
      </h2>
      <button @click="toggleCollapse" class="SideFilterDropdown_toggle outline-none p-2" :class="{ open: open }">
        <i class="far fa-chevron-left"></i>
      </button>
    </div>

    <div class="SideFilterDropdown_body overflow-hidden" v-show="open">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "Side.SideFilterDropdown",
  props: {
    title: {
      type: String,
      required: true,
    },
    initialOpen: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      open: this.initialOpen,
    }
  },
  methods: {
    toggleCollapse() {
      this.open = !this.open
    },
  },
}
</script>

<style scoped>
.SideFilterDropdown h2 {
  cursor: pointer;
}

.SideFilterDropdown_toggle.open {
  transform: rotate(90deg);
}
</style>
